export default [
    {
        path: "/Helper/UploadData/:title",
        name: "HelperUploadData",
        component: () => import("@/components/Helper/UploadData.vue"),
        meta: {
            name: "Helper",
            menuTitle : "Upload",            
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Helper/UploadTemplate",
        name: "UploadTemplate",
        component: () => import("@/components/Helper/UploadTemplate.vue"),
        meta: {
            name: "Helper",
            menuTitle : "Upload Template",               
            requiresAuth: true
        },
        props: true
    }    
];